import client from './client';
import { Expense } from '../types/entities';
import { ApiResponse, CreateExpenseRequest } from '../types/api';

interface ExpenseFilters {
  startDate?: string;
  endDate?: string;
  vehicleId?: number;
  tripId?: number;
  type?: string;
}

export const expenseAPI = {
  getAll: async (filters?: ExpenseFilters): Promise<Expense[]> => {
    const response = await client.get('/expenses', { params: filters });
    return response.data.data;
  },

  getByVehicle: async (vehicleId: number): Promise<{ expenses: Expense[]; total: number }> => {
    const response = await client.get(`/expenses/vehicles/${vehicleId}`);
    return response.data.data;
  },

  getByTrip: async (tripId: number): Promise<{ expenses: Expense[]; total: number }> => {
    const response = await client.get(`/expenses/trips/${tripId}`);
    return response.data.data;
  },

  getById: async (id: number): Promise<Expense> => {
    const response = await client.get(`/expenses/${id}`);
    return response.data.data;
  },

  create: async (data: CreateExpenseRequest): Promise<Expense> => {
    const response = await client.post('/expenses', data);
    return response.data.data;
  },

  update: async (id: number, data: CreateExpenseRequest): Promise<Expense> => {
    const response = await client.put(`/expenses/${id}`, data);
    return response.data.data;
  },

  delete: async (id: number): Promise<ApiResponse<null>> => {
    const response = await client.delete(`/expenses/${id}`);
    return response.data;
  },
};
